<template>

  <el-row :gutter="5">
    <el-col :span="8" style="padding-top:20px;text-align:center;">
        <span class="label">Report Type</span>
        <el-select v-model="reportType" class="m-2" style="width:220px;" placeholder="Select Report Type" @change="selectReportType()" clearable>
            <el-option label="Factsheet" value="Factsheet"></el-option>
            <el-option label="Leaflet" value="Leaflet"></el-option>
            <el-option label="APxJ" value="APxJ"></el-option>
        </el-select>
    </el-col>
    <el-col :span="8"><h2 class="heading">Monthly Report List</h2></el-col>
    <el-col :span="8" style="padding-top:20px;text-align:center;" v-if="reportType != null">
        <el-button v-if="reportType == 'Factsheet' && global.hasRight('report-factsheet', 'creator')" 
            @click="$router.push('/report/createReport?reportType=Factsheet')"><el-icon><Plus/></el-icon> &nbsp; Add Factsheet Workflow</el-button>
        <el-button v-else-if="reportType == 'Leaflet' && global.hasRight('report-leaflet', 'dataImport')" 
            @click="$router.push('/report/createReport?reportType=Leaflet')"><el-icon><Plus/></el-icon> &nbsp; Add Leaflet Workflow</el-button>
        <el-button v-else-if="reportType == 'APxJ' && global.hasRight('report-APxJ', 'dataImport')" 
            @click="$router.push('/report/createReport?reportType=APxJ')"><el-icon><Plus/></el-icon> &nbsp; Add APxJ Workflow</el-button>
    </el-col>
  </el-row>

  <el-table :data="reportList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName">
    <el-table-column prop="reportType" label="Report type"/>
    <el-table-column prop="reportDate" label="Report date" align="center" />
    <el-table-column prop="fullname" label="Creator" />
    <el-table-column prop="lastupdate" label="Lastupdate" align="center"/>
    <el-table-column prop="status" label="Status" align="center"/>
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.canImport" title="Import data" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)" >
                {{scope.row.reportType=='APxJ'?'generatePDF':'importData'}}</a>
            <a href="" v-if="scope.row.canVerify" title="Verify data" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)">Verify</a>
            <a href="" v-if="scope.row.canConfirm" title="Confirm report" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)">Confirm</a>
            <a href="" v-if="scope.row.canRevise || scope.row.canUpdate || scope.row.canModify" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)" >Revise</a>
            <a href="" v-if="scope.row.canApprove" title="Review / approve reports" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)" >Approve</a>
            <a href="" v-if="scope.row.canPublish" title="Publish reports" class="op"
                @click.prevent="$router.push('/report/viewReport?code=' + scope.row.idMD5)" >Publish</a>
            <el-icon :size="16" @click="$router.push('/report/viewReport?code=' + scope.row.idMD5)" title="View details" class="op">
                <document />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" 
    @current-change="getReportList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Document, Plus } from '@element-plus/icons-vue'

export default {
    components: {
        Document, Plus
    },
    data() {
        return {
            reportType: null,
            reportList: [],
            page: {},
            errMsg: '',
            global,
        }
    },
    watch: {
        $route: {
            handler() { //解决参数不同页面不刷新的问题
                this.reportType = this.$route.query.reportType;
                this.getReportList(1);
            }
        },
        reportType(newValue, oldValue) {
            this.global.index = "report-" + newValue;
        }
    },
    async mounted() {
        if (this.$route.query && this.$route.query.reportType)
            this.reportType = this.$route.query.reportType;
        this.getReportList(1);
        this.global.index = "report-" + (this.reportType ? this.reportType : "Factsheet");
    },
    methods: {
        selectReportType() {
            this.getReportList(1)
        },
        async getReportList(pageNo) {
            let data = {pageNo: pageNo};
            if (this.reportType)
                data["reportType"] = this.reportType;
            console.log(data.toString())
            let result = await AXIOS("/report/reportList", data);
            if (result.success) {
                this.reportList = result.data.list;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        }
    }
}
</script>

<style>
    .errMsg {
        padding-left:20px;
    }
    .successMsg {
        padding-left:20px;
    }
</style>